import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: () => ({
      borderRadius: '10px',
      paddingLeft: '0.5rem',
      backgroundColor: '#F8FAFE',
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #F8FAFE',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#F8FAFE',
      },
    }),
    input: ({ theme }) => ({
      paddingTop: '0 !important',
      fontSize: '16px',
      lineHeight: 1.2,
      fontWeight: 600,
      color: '#525E7E',
      '&::-webkit-input-placeholder': {
        color: theme.palette.text.secondary,
        opacity: 1,
      },
    }),
  },
};
